import { useState } from 'react';
import RestHttpClient from '../../../../../common/RestHttpClient';
import { SaveIdentityCheckFieldsBody } from '../../../../../generated/ApiClient';

interface SaveData {
  dealId?: number;
  ksvId?: string;
  firstName?: string;
  lastName?: string;
  birthDate?: Date | null;
  street?: string;
  houseNumber?: string;
  zipCode?: string;
  city?: string;
  companyName?: string;
  uidNumber?: string | null;
  commercialRegisterNumber?: string | null;
}

export function useIdentityCheckSave() {
  const [saving, setSaving] = useState(false);

  const save = async (customerId: number, data: SaveData) => {
    setSaving(true);
    try {
      await RestHttpClient.saveIdentityCheckFields(
        customerId,
        new SaveIdentityCheckFieldsBody({
          dealId: data.dealId,
          ksvId: data.ksvId,
          firstName: data.firstName,
          lastName: data.lastName,
          birthDate: data.birthDate ?? undefined,
          street: data.street,
          houseNumber: data.houseNumber,
          zipCode: data.zipCode,
          city: data.city,
          companyName: data.companyName,
          uidNumber: data.uidNumber ?? undefined,
          commercialRegisterNumber: data.commercialRegisterNumber ?? undefined,
        })
      );
    } finally {
      setSaving(false);
    }
  };

  return { save, saving };
}
